import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useMutation } from '@tanstack/react-query'

const updateSendToPv = async (claimFormId: string) => {
  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/${claimFormId}/send-to-pv`,
  )

  return response.data
}

const useSendToPv = () => {
  const mutation = useMutation({
    mutationKey: ['useSendToPv'],
    mutationFn: async (claimFormId: string) => updateSendToPv(claimFormId),
  })

  return mutation
}

export { useSendToPv }
